import { useTranslation } from 'next-i18next';
import { useAuth } from '@zep/auth';
import { useNextRouter } from '@zep/next';
import { Pagination } from '@zep/ui';
import Empty from '../../components/service/common/Empty';
import { InquiryBanner } from '../../components/service/stores/StoreBanner/InquiryBanner';
import AppCategoryTagList from '../../components/service/stores/StoreList/AppCategoryTagList';
import StoreFilter from '../../components/service/stores/StoreList/StoreFilter';
import StoreGrid from '../../components/service/stores/StoreList/StoreGrid';
import { useStoreAppSubCategories } from '../../consts';
import { useStoreItems } from '../../services';
import { StoreFilterType, StoreItemType } from '../../types/StoreTypes';
export const StoreAssetsPageView = () => {
  const router = useNextRouter();
  const {
    t
  } = useTranslation(['store']);
  const {
    user
  } = useAuth();
  const appCategories = useStoreAppSubCategories();
  const assetType: StoreItemType = (`${router.query.type}` || 'map') as StoreItemType;
  const isApp = assetType === 'app' || assetType === 'game';
  const filter: StoreFilterType = {
    ...router.query,
    type: assetType,
    subCategory: Number(router.query.subCategory) || 0,
    page: Number(router.query.page) || 1
  };
  const {
    data: assetData
  } = useStoreItems(assetType, filter, !!user?.isEdu, router.locale);

  /**
   * 필터의 값이 변경될 때 호출되는 함수, 페이지가 바뀌는 것이 아니면 1페이지로 돌아간다
   * @param key 필터의 키(타입, 정렬방식 등)
   * @param value 바뀔 필터의 값
   */
  const handleFilterChange = (key: keyof StoreFilterType, value?: string | number) => {
    router.push({
      pathname: router.pathname,
      query: {
        ...router.query,
        ...filter,
        [key]: value,
        page: key !== 'page' ? 1 : value
      }
    });
  };
  return <>
      <StoreFilter filter={filter} onFilterChange={handleFilterChange} totalCount={assetData.pager.totalItems} isPriceHidden={user?.isEdu} data-sentry-element="StoreFilter" data-sentry-source-file="assets.tsx" />
      {isApp && <>
          <InquiryBanner style={{
        marginTop: '28px'
      }} />
          {assetType === 'app' && <AppCategoryTagList style={{
        marginTop: '20px'
      }} items={appCategories} currentItem={filter.subCategory} onCategoryChange={newSubCategory => handleFilterChange('subCategory', newSubCategory)} />}
        </>}
      {assetData.results.length > 0 ? <>
          <StoreGrid type={assetType} items={assetData.results} />
          <Pagination lastPageNo={assetData.pager.totalPages} nowPageNo={assetData.pager.currentPage} printableCount={assetData.pager.pageSize} onPageChange={page => handleFilterChange('page', page)} />
        </> : <Empty emptyItem={t(`store:store_empty_${assetType === 'game' ? 'minigame' : assetType}`)} useCustomMessage />}
    </>;
};